import axiosInstance from './axios-instance';
import { isMutationSuccess } from './cache-utils';
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from './cache-invalidation';

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const withScopedAccountId = (payload: any) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  const scopedAccountId = getScopedAccountId(payload.accountId);
  if (!(scopedAccountId > 0)) {
    return payload;
  }
  return {
    ...payload,
    accountId: scopedAccountId,
  };
};

const addDraperyOrderSummaryComponent = async (payload: any) => {
  try {
    const response = await axiosInstance.post<any>(
      '/draperyOrderSummaryComponent/add',
      withScopedAccountId(payload)
    );
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error('Error add drapery order summary component:', error);
    throw error;
  }
};
const editDraperyOrderSummaryComponent = async (payload: any) => {
  try {
    const response = await axiosInstance.put<any>(
      '/draperyOrderSummaryComponent/edit',
      withScopedAccountId(payload)
    );
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error('Error edit drapery order summary component:', error);
    throw error;
  }
};
const searchDraperyOrderSummaryComponents = async (draperyOrderSummaryId: number) => {
  try {
    const response = await axiosInstance.get<any>(
      `/draperyOrderSummaryComponent/search?draperyOrderSummaryId=${draperyOrderSummaryId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error search drapery order summary component:', error);
    throw error;
  }
};

const deleteDraperyOrderSummaryComponents = async (payload: any) => {
  try {
    const response = await axiosInstance.post<any>(
      '/draperyOrderSummaryComponent/delete',
      payload
    );
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
    }
    return response.data;
  } catch (error) {
    console.error('Error delete drapery order summary component:', error);
    throw error;
  }
};
export {
  addDraperyOrderSummaryComponent,
  editDraperyOrderSummaryComponent,
  searchDraperyOrderSummaryComponents,
  deleteDraperyOrderSummaryComponents,
};
